/**
 * Purpose: Generic dashboard shell — header slot, module navigation, content
 *          area. Responsive: rail nav on desktop, tab strip on mobile. Knows
 *          nothing about which modules exist or which vertical it serves.
 * Inputs: header (node), items ([{ id, label, icon, badge }]), activeId,
 *         onSelect(id), children (the active module's content).
 * Outputs: two-column layout (lg+) / stacked layout (below lg).
 *
 * Reusable by Hotels, Marketplace, Mosques, Events: pass a different descriptor
 * list and a different header. No business-specific imports.
 */
import React from 'react';
import DashboardNav from './DashboardNav';

const DashboardLayout = ({ header = null, items = [], activeId, onSelect, children }) => (
  <div className="mx-auto max-w-screen-2xl px-4 py-4 sm:px-6 lg:px-8">
    {header}

    <div className="mt-4 lg:grid lg:grid-cols-[15rem_minmax(0,1fr)] lg:gap-6">
      {/* Desktop rail */}
      <aside className="hidden lg:block lg:sticky lg:top-20 lg:self-start" aria-label="Dashboard navigation">
        <DashboardNav items={items} activeId={activeId} onSelect={onSelect} variant="rail" />
      </aside>

      {/* Mobile tab strip */}
      <div className="lg:hidden">
        <DashboardNav items={items} activeId={activeId} onSelect={onSelect} variant="tabs" />
      </div>

      <main className="mt-4 min-w-0 lg:mt-0">{children}</main>
    </div>
  </div>
);

export default DashboardLayout;
